import * as yup from 'yup';
import type { FormData } from '@components/ShareLinkModal/ShareLinkModal.types';

export const createValidationSchema = (
  t: (key: string) => string,
): yup.ObjectSchema<FormData> =>
  yup.object({
    clientFirstName: yup.string().trim().required(t('validation.required')),
    clientLastName: yup.string().trim().required(t('validation.required')),
    clientEmail: yup
      .string()
      .trim()
      .required(t('validation.required'))
      .email(t('validation.email')),
    language: yup.string().trim().required(t('validation.required')),
  });
